export const FETCH_TRANSACTION_HISTORY_REQUEST = "FETCH_TRANSACTION_HISTORY_REQUEST";
export const FETCH_TRANSACTION_HISTORY_SUCCESS = "FETCH_TRANSACTION_HISTORY_SUCCESS";
export const FETCH_TRANSACTION_HISTORY_FAILURE = "FETCH_TRANSACTION_HISTORY_FAILURE";
